 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Accounting~Claim1_Main~Claim2_Main~Claim3_Main~Claim4_Main~Claims~Complains~Payments~Policies~Quotas~77dcb2d1":"Accounting~Claim1_Main~Claim2_Main~Claim3_Main~Claim4_Main~Claims~Complains~Payments~Policies~Quotas~77dcb2d1","Accounting":"Accounting","Claim1_Main":"Claim1_Main","Claim2_Main":"Claim2_Main","Claim3_Main":"Claim3_Main","Claim4_Main":"Claim4_Main","Claims":"Claims","Complains":"Complains","Historical~Policies~SegPolicies":"Historical~Policies~SegPolicies","Policies":"Policies","Payments":"Payments","Quotas":"Quotas","Quotations":"Quotations","Blank":"Blank","Broker":"Broker","Check":"Check","Claim1":"Claim1","Claim1_Adm":"Claim1_Adm","Claim1_Eval":"Claim1_Eval","Claim1_For":"Claim1_For","Claim2":"Claim2","Claim2_Adm":"Claim2_Adm","Claim2_Eval":"Claim2_Eval","Claim2_For":"Claim2_For","Claim3":"Claim3","Claim3_Adm":"Claim3_Adm","Claim3_Eval":"Claim3_Eval","Claim3_For":"Claim3_For","Claim4":"Claim4","Claim4_Adm":"Claim4_Adm","Claim4_Eval":"Claim4_Eval","Claim4_For":"Claim4_For","Company":"Company","Complaint":"Complaint","Contact":"Contact","Customers":"Customers","Dashboard":"Dashboard","Evaluation1":"Evaluation1","Evaluation2":"Evaluation2","Evaluation3":"Evaluation3","Evaluation4":"Evaluation4","Historical":"Historical","SegPolicies":"SegPolicies","Location":"Location","Moneda":"Moneda","MyPolicies":"MyPolicies","MyQuotation":"MyQuotation","Mypayments":"Mypayments","Office":"Office","Payment":"Payment","Paymentreview":"Paymentreview","Paymentsr":"Paymentsr","Profile":"Profile","Query":"Query","Quotation":"Quotation","Quotation1":"Quotation1","Quotation2":"Quotation2","Quotation3":"Quotation3","Quotation4":"Quotation4","Quotations1":"Quotations1","Quotations2":"Quotations2","Quotations3":"Quotations3","Quotations4":"Quotations4","Register":"Register","Roles":"Roles","SegQuotation":"SegQuotation","Services":"Services","Home":"Home","Simulator":"Simulator","Tarif":"Tarif","TypeCoverage":"TypeCoverage","Typepolicie":"Typepolicie","Users":"Users","Vehicles":"Vehicles"}[chunkId]||chunkId) + "." + {"Accounting~Claim1_Main~Claim2_Main~Claim3_Main~Claim4_Main~Claims~Complains~Payments~Policies~Quotas~77dcb2d1":"9d46bc97","Accounting":"397c5e04","Claim1_Main":"21aa3b9f","Claim2_Main":"c0708dac","Claim3_Main":"7c065626","Claim4_Main":"9efda5c8","Claims":"49c37969","Complains":"0209ae89","Historical~Policies~SegPolicies":"f8bd09ef","Policies":"5c16cfd0","Payments":"c70f5266","Quotas":"a3835ade","Quotations":"18f36284","Blank":"aaff1047","Broker":"c9688d22","Check":"84bb0ee0","Claim1":"fdce3bf0","Claim1_Adm":"b07e7aa7","Claim1_Eval":"6ca9213c","Claim1_For":"ac1bdcc5","Claim2":"1df69364","Claim2_Adm":"080ab684","Claim2_Eval":"098d849b","Claim2_For":"1e9747ac","Claim3":"4cfaa4e7","Claim3_Adm":"e2c85b03","Claim3_Eval":"75618a6c","Claim3_For":"d7a4458a","Claim4":"5da2067d","Claim4_Adm":"c6812d21","Claim4_Eval":"c211ba5d","Claim4_For":"4a7c7f87","Company":"2f1c070b","Complaint":"eac2a42c","Contact":"d9930266","Customers":"f1c39eed","Dashboard":"e1069337","Evaluation1":"cfec38fe","Evaluation2":"83d0ff13","Evaluation3":"178b4eed","Evaluation4":"d7deb7fb","Historical":"485288a5","SegPolicies":"4a59302f","Location":"ff5a0cf7","Moneda":"0293a4c9","MyPolicies":"5da9f1d9","MyQuotation":"49d25168","Mypayments":"21ec71f4","Office":"a345cb2d","Payment":"affa7dad","Paymentreview":"2219c6f1","Paymentsr":"709599e7","Profile":"465fefd1","Query":"400c99e4","Quotation":"f7f1c3ef","Quotation1":"96891454","Quotation2":"6e06e014","Quotation3":"8cdbccc6","Quotation4":"e392ae62","Quotations1":"d1bc5dec","Quotations2":"c2106dce","Quotations3":"b01f082a","Quotations4":"79005b49","Register":"a0df3d8f","Roles":"1ccaceca","SegQuotation":"742eaccb","Services":"b489258e","Home":"a44698d8","Simulator":"508292dc","Tarif":"33ebe4de","TypeCoverage":"ed4b838a","Typepolicie":"45121c86","Users":"18a1e7cd","Vehicles":"57e9b393","chunk-1099c096":"b091af3c","chunk-129384f5":"d5488eec","chunk-1acdb89a":"1563ae6e","chunk-23bfd56b":"f7d1db52","chunk-2820fa6d":"7eef7768","chunk-2d0b2afc":"c6b9d26c","chunk-2d0b5d46":"06348dfd","chunk-2d0bacf7":"d8ea5496","chunk-2d0bdef6":"df24d536","chunk-2d0bfe9a":"d6263264","chunk-2d0c4de6":"49812b82","chunk-2d0cb6b7":"44208cda","chunk-2d0d36df":"c8cda076","chunk-2d0d3e54":"6418b281","chunk-2d0d602d":"202f0f1e","chunk-2d0df288":"ddcfc5a8","chunk-2d0e188e":"8e8f1080","chunk-2d0e1dfe":"586106f0","chunk-2d0f045d":"154ab28a","chunk-2d0f08ae":"5c734c14","chunk-2d20f8e9":"5546036f","chunk-2d213938":"e818b56c","chunk-2d216214":"6bb1b029","chunk-2d216257":"acab445a","chunk-2d21b82a":"4c622ccf","chunk-2d2389ac":"827d07dc","chunk-315b4da4":"eb6214dc","chunk-33fbb264":"12232375","chunk-410ad399":"e70e0123","chunk-48596e57":"effcef13","chunk-56ce156d":"0a3f2588","chunk-57f66a28":"7a8ba75d","chunk-768001c6":"60c7da40","chunk-77143487":"e406819f","chunk-7a79561e":"22c6de4f","chunk-7c429d94":"2b7f9109","chunk-9f37b892":"12c75d4f","chunk-c899e244":"5bdf3822","chunk-d4630e98":"1c9dbd46","chunk-e2edfad8":"796ce2fb","chunk-ee8e718e":"6e1d75dc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Accounting":1,"Claim1_Main":1,"Claim2_Main":1,"Claim3_Main":1,"Claim4_Main":1,"Claims":1,"Complains":1,"Policies":1,"Payments":1,"Quotas":1,"Quotations":1,"Broker":1,"Claim1":1,"Claim1_Adm":1,"Claim1_Eval":1,"Claim1_For":1,"Claim2":1,"Claim2_Adm":1,"Claim2_Eval":1,"Claim2_For":1,"Claim3":1,"Claim3_Adm":1,"Claim3_Eval":1,"Claim3_For":1,"Claim4":1,"Claim4_Adm":1,"Claim4_Eval":1,"Claim4_For":1,"Complaint":1,"Customers":1,"Historical":1,"SegPolicies":1,"Location":1,"Moneda":1,"MyPolicies":1,"MyQuotation":1,"Mypayments":1,"Office":1,"Paymentreview":1,"Roles":1,"Tarif":1,"TypeCoverage":1,"Typepolicie":1,"Users":1,"Vehicles":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Accounting~Claim1_Main~Claim2_Main~Claim3_Main~Claim4_Main~Claims~Complains~Payments~Policies~Quotas~77dcb2d1":"Accounting~Claim1_Main~Claim2_Main~Claim3_Main~Claim4_Main~Claims~Complains~Payments~Policies~Quotas~77dcb2d1","Accounting":"Accounting","Claim1_Main":"Claim1_Main","Claim2_Main":"Claim2_Main","Claim3_Main":"Claim3_Main","Claim4_Main":"Claim4_Main","Claims":"Claims","Complains":"Complains","Historical~Policies~SegPolicies":"Historical~Policies~SegPolicies","Policies":"Policies","Payments":"Payments","Quotas":"Quotas","Quotations":"Quotations","Blank":"Blank","Broker":"Broker","Check":"Check","Claim1":"Claim1","Claim1_Adm":"Claim1_Adm","Claim1_Eval":"Claim1_Eval","Claim1_For":"Claim1_For","Claim2":"Claim2","Claim2_Adm":"Claim2_Adm","Claim2_Eval":"Claim2_Eval","Claim2_For":"Claim2_For","Claim3":"Claim3","Claim3_Adm":"Claim3_Adm","Claim3_Eval":"Claim3_Eval","Claim3_For":"Claim3_For","Claim4":"Claim4","Claim4_Adm":"Claim4_Adm","Claim4_Eval":"Claim4_Eval","Claim4_For":"Claim4_For","Company":"Company","Complaint":"Complaint","Contact":"Contact","Customers":"Customers","Dashboard":"Dashboard","Evaluation1":"Evaluation1","Evaluation2":"Evaluation2","Evaluation3":"Evaluation3","Evaluation4":"Evaluation4","Historical":"Historical","SegPolicies":"SegPolicies","Location":"Location","Moneda":"Moneda","MyPolicies":"MyPolicies","MyQuotation":"MyQuotation","Mypayments":"Mypayments","Office":"Office","Payment":"Payment","Paymentreview":"Paymentreview","Paymentsr":"Paymentsr","Profile":"Profile","Query":"Query","Quotation":"Quotation","Quotation1":"Quotation1","Quotation2":"Quotation2","Quotation3":"Quotation3","Quotation4":"Quotation4","Quotations1":"Quotations1","Quotations2":"Quotations2","Quotations3":"Quotations3","Quotations4":"Quotations4","Register":"Register","Roles":"Roles","SegQuotation":"SegQuotation","Services":"Services","Home":"Home","Simulator":"Simulator","Tarif":"Tarif","TypeCoverage":"TypeCoverage","Typepolicie":"Typepolicie","Users":"Users","Vehicles":"Vehicles"}[chunkId]||chunkId) + "." + {"Accounting~Claim1_Main~Claim2_Main~Claim3_Main~Claim4_Main~Claims~Complains~Payments~Policies~Quotas~77dcb2d1":"e3b0c442","Accounting":"76dfd4e5","Claim1_Main":"0a88025f","Claim2_Main":"a40923e0","Claim3_Main":"43089827","Claim4_Main":"a4e8999f","Claims":"3fdf9f67","Complains":"ba0cdba9","Historical~Policies~SegPolicies":"e3b0c442","Policies":"492992d5","Payments":"782ec472","Quotas":"e791ce66","Quotations":"0424208c","Blank":"e3b0c442","Broker":"c965fd5e","Check":"e3b0c442","Claim1":"aa4111fc","Claim1_Adm":"d15fc46c","Claim1_Eval":"9e3f99a8","Claim1_For":"81357107","Claim2":"a6028a7a","Claim2_Adm":"69861f19","Claim2_Eval":"4c7a1e85","Claim2_For":"50e44c65","Claim3":"caae29e1","Claim3_Adm":"b18dc106","Claim3_Eval":"c245568f","Claim3_For":"f2b89c91","Claim4":"ec3edc77","Claim4_Adm":"84471eb2","Claim4_Eval":"e881b613","Claim4_For":"26e62908","Company":"e3b0c442","Complaint":"35f953da","Contact":"e3b0c442","Customers":"f140a50e","Dashboard":"e3b0c442","Evaluation1":"e3b0c442","Evaluation2":"e3b0c442","Evaluation3":"e3b0c442","Evaluation4":"e3b0c442","Historical":"85030b5d","SegPolicies":"a0d48a11","Location":"99d4294f","Moneda":"57602d49","MyPolicies":"76a1d361","MyQuotation":"81b08b9f","Mypayments":"c4306140","Office":"3c812de7","Payment":"e3b0c442","Paymentreview":"66735f61","Paymentsr":"e3b0c442","Profile":"e3b0c442","Query":"e3b0c442","Quotation":"e3b0c442","Quotation1":"e3b0c442","Quotation2":"e3b0c442","Quotation3":"e3b0c442","Quotation4":"e3b0c442","Quotations1":"e3b0c442","Quotations2":"e3b0c442","Quotations3":"e3b0c442","Quotations4":"e3b0c442","Register":"e3b0c442","Roles":"ebcf1645","SegQuotation":"e3b0c442","Services":"e3b0c442","Home":"e3b0c442","Simulator":"e3b0c442","Tarif":"f0dca5ba","TypeCoverage":"32c01236","Typepolicie":"607295d8","Users":"3f0c723f","Vehicles":"25ac882e","chunk-1099c096":"e3b0c442","chunk-129384f5":"e3b0c442","chunk-1acdb89a":"e3b0c442","chunk-23bfd56b":"e3b0c442","chunk-2820fa6d":"e3b0c442","chunk-2d0b2afc":"e3b0c442","chunk-2d0b5d46":"e3b0c442","chunk-2d0bacf7":"e3b0c442","chunk-2d0bdef6":"e3b0c442","chunk-2d0bfe9a":"e3b0c442","chunk-2d0c4de6":"e3b0c442","chunk-2d0cb6b7":"e3b0c442","chunk-2d0d36df":"e3b0c442","chunk-2d0d3e54":"e3b0c442","chunk-2d0d602d":"e3b0c442","chunk-2d0df288":"e3b0c442","chunk-2d0e188e":"e3b0c442","chunk-2d0e1dfe":"e3b0c442","chunk-2d0f045d":"e3b0c442","chunk-2d0f08ae":"e3b0c442","chunk-2d20f8e9":"e3b0c442","chunk-2d213938":"e3b0c442","chunk-2d216214":"e3b0c442","chunk-2d216257":"e3b0c442","chunk-2d21b82a":"e3b0c442","chunk-2d2389ac":"e3b0c442","chunk-315b4da4":"e3b0c442","chunk-33fbb264":"e3b0c442","chunk-410ad399":"e3b0c442","chunk-48596e57":"e3b0c442","chunk-56ce156d":"e3b0c442","chunk-57f66a28":"e3b0c442","chunk-768001c6":"e3b0c442","chunk-77143487":"e3b0c442","chunk-7a79561e":"e3b0c442","chunk-7c429d94":"e3b0c442","chunk-9f37b892":"e3b0c442","chunk-c899e244":"e3b0c442","chunk-d4630e98":"e3b0c442","chunk-e2edfad8":"e3b0c442","chunk-ee8e718e":"e3b0c442"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://test.sabeeinsurance.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
